export const GUIDES = {
  dashboard: {
    about: 'Your home base. See your BETH balance, your checks and recent activity, and jump to every service from the buttons above.',
    steps: [
      'Check your balance and recent transactions at a glance.',
      'Use Mint Check to write a new Treasury Check against your credit line.',
      'Use Exchange & Swap to trade ETH, USDC and BETH USD.',
      'Use Buy / Cash Out BETH USD to buy BETH at $1.00 or turn it back into dollars.',
      'Use Point of Sale to accept a customer\'s check as payment.',
      'Open Banking & Credit to manage your subscription, wallet and credit line.',
    ],
  },
  banking: {
    about: 'Everything that powers your account: your wallet, your Treasury Officer subscription, your credit line and network gas.',
    steps: [
      'Connect or confirm your wallet so checks and BETH can be sent to you.',
      'Subscribe as a Treasury Officer to unlock check minting and credit line eligibility.',
      'Request a credit line, then sign the Credit Agreement and Promissory Note.',
      'Upload collateral documents when asked. You can add them later if you need to.',
      'Top up a little ETH for gas so on-chain actions from your wallet can go through.',
    ],
    note: 'Credit line payments are interest-only and are collected automatically in BETH on the due date.',
  },
  'mint-check': {
    about: 'Write a Treasury Check on-chain. The amount is drawn from your approved credit line and the check goes to the payee you choose.',
    steps: [
      'Enter the amount. It cannot exceed your available credit.',
      'Leave the payee empty to pay yourself, or enter a subscriber\'s email or a wallet address.',
      'Review the live preview of the check face.',
      'Pay the 1% transaction fee if it is shown, then press Mint Check.',
      'The check is recorded on Base, and a receipt with its claim link is emailed to you and the payee.',
    ],
    note: 'Requires an active Treasury Officer subscription, an approved credit line and a signed agreement. Limit: 5 checks every 7 days.',
  },
  swap: {
    about: 'Trade ETH, USDC and BETH USD on Uniswap straight from your wallet. Every swap is reviewed by the admin before it runs.',
    steps: [
      'Choose what you are paying with and what you want to receive.',
      'Enter the amount and press Get quote to see the price, pool fee and service fee.',
      'Press Request swap. Your request appears under My swap requests.',
      'Once approved, the swap runs on-chain and the status turns Completed with a link to the transaction.',
    ],
    note: 'Keep a small amount of ETH in your wallet for network gas. For large amounts, the Buy / Cash Out desk gives an exact $1.00 price.',
  },
  desk: {
    about: 'Buy BETH USD or cash it out at exactly $1.00, in any amount, with no price slippage. A small desk fee applies each way.',
    steps: [
      'To buy, send USDC to the treasury wallet shown (or make a bank transfer), then enter the amount and your payment reference.',
      'To cash out, enter how much BETH USD to redeem and where you want to be paid.',
      'Check the fee breakdown, then submit your request.',
      'The admin confirms your payment and mints your BETH, or holds your BETH and sends your dollars.',
      'Follow each request\'s status under My desk requests.',
    ],
    note: 'Tier 2 members can also cash out straight from unused credit, with no BETH needed. Treasury Officers with a signed credit line can turn credit into BETH USD for trading, within the reserve room shown.',
  },
  pos: {
    about: 'Accept BETH Treasury Checks as payment at your counter or shop. Accepted checks move into your wallet on-chain.',
    steps: [
      'Press Scan check QR and point your camera at the customer\'s check, or paste the check link.',
      'Confirm the amount and that it shows Genuine and unclaimed.',
      'Press Accept to move the check into your wallet.',
      'Today\'s totals and recent acceptances update automatically.',
    ],
  },
  'exchange-agreements': {
    about: 'Create and sign exchange agreements that use a Treasury Check or crypto check toward a property or loan obligation.',
    steps: [
      'Choose a Treasury Check exchange or a Crypto Check exchange.',
      'Fill in the property address, legal description and obligation details.',
      'Review the preview, then type your full legal name to sign.',
      'Open any agreement under My agreements to view or print it.',
    ],
  },
  'tax-forms': {
    about: 'Your IRS Form 8824 records for like-kind exchanges, prepared from your account activity.',
    steps: [
      'Pick a transaction to open its Form 8824 details.',
      'Review the figures and print or save them for your tax preparer.',
    ],
    note: 'These forms are provided for your records. Please confirm them with a qualified tax professional before filing.',
  },
  'credit-agreement': {
    about: 'The Subscriber Credit Agreement and Promissory Note behind your credit line. Every check you mint is a draw under this agreement.',
    steps: [
      'Read the agreement terms, limit and payment schedule.',
      'Type your full legal name and sign to put it in force.',
      'Print or save a copy for your records at any time.',
    ],
  },

  'admin-dashboard': {
    about: 'Platform overview: network status, totals and the latest subscriber activity.',
    steps: ['Check the network card to confirm the contracts are live.', 'Scan the totals and recent transactions for anything unusual.', 'Use the tabs above to act on any area.'],
  },
  'admin-analytics': {
    about: 'Site traffic and subscriber activity, including trailer views.',
    steps: ['Review visits for the last 7 days and the top pages.', 'See which subscribers were active recently.'],
  },
  'admin-videos': {
    about: 'Create and manage the AI marketing videos and the landing page trailer.',
    steps: ['Write a prompt or pick a template and generate a video.', 'Preview the result, then set it as the trailer or share it.'],
  },
  'admin-bank': {
    about: 'The BETHCOIN banking system: the master account, every subscriber\'s account and routing number, balances, withdrawals and the full activity log.',
    steps: [
      'Keep the master account funded. It holds the treasury float that moves into subscriber accounts.',
      'Press Open account for a subscriber to give them an account and routing number. Their bank balance then mirrors their BETH USD 1:1.',
      'Use Sync (or Sync all) to match bank balances to BETH USD right away. It also runs automatically every 10 minutes.',
      'Freeze an account to stop its syncing and withdrawals. Unfreeze to restore it.',
      'Approve or reject ACH and wire withdrawals. Approving holds the BETH, sends the money from the subscriber\'s account, then burns the BETH and books your fee.',
      'In Outbound institution feed, create an integration key for each receiving institution (name and web address). Every bank event is then pushed to them as a signed message. Use Send test message to check delivery.',
    ],
  },
  'admin-partnerships': {
    about: 'Direct bank connectivity: discover real banks and their official API docs, register and verify their documented endpoints, apply for API access, receive cryptographically-verified bank approvals, store encrypted credentials, and transmit only authorized data. Sub-tabs: Discovery, Directory & Endpoints, Access & Approvals, Gateway & Transmit, Quick Partnership.',
    steps: [
      'Discovery: search for a bank or capability (e.g. "ACH API"). The system proposes real institutions and crawls their official portals for evidence. Press "Add to directory" to keep one. Results are unverified candidates — discovery never grants access.',
      'Directory & Endpoints: Seed known providers or add institutions manually. Open one, register its documented API endpoints (with a source reference), press Verify to check the endpoint is reachable, then Authorize it for use. DISCOVERED → VERIFIED → AUTHORIZED.',
      'Applications & Transmit: create and send the partnership request, and once a bank approves you, paste the OAuth2 credentials + data URL and transmit banking data.',
      'A bank must review and approve you before any data is accepted — a documented endpoint or a routing number alone does not grant access.',
    ],
    note: 'The direct gateway talks to a bank\'s APIs only after that bank authorizes you and issues credentials. No approval is accepted unless its signature/credentials are verified.',
  },
  bank: {
    about: 'Your BETHCOIN bank account with its own account and routing number. Its balance mirrors your BETH USD 1:1, so every check, buy, cash-out or transfer shows up here.',
    steps: [
      'Copy your account and routing number to receive deposits.',
      'Check your bank balance against your BETH USD balance. They match automatically.',
      'To send money to another bank, choose ACH or wire, enter the receiving account details and amount, and submit.',
      'The administrator approves each withdrawal. Follow its status under My withdrawals.',
    ],
  },
  'admin-earnings': {
    about: 'Everything the platform earns: mint, redeem, swap and credit cash-out fees, Tier 2 subscriptions and reserve interest.',
    steps: [
      'Read the totals and the 30-day chart by source.',
      'Change the fee percentages and press Save fees. New fees apply to new requests only.',
      'Record interest your bank or Treasury bills paid on the reserve.',
    ],
  },
  'admin-desk': {
    about: 'Approve buys, cash-outs and Tier 2 credit cash-outs from subscribers, and control who can cash out from credit.',
    steps: [
      'Buy requests: confirm the payment arrived, then press Approve to record the reserve and mint the BETH.',
      'Cash-outs: press Approve to hold the BETH or draw the credit, send the payout, then press Mark paid.',
      'Use Reject, Return BETH or Restore credit to cancel a request.',
      'In Credit Cash-Out, turn the feature on or off and Grant, Revoke or Reset each subscriber\'s access.',
    ],
  },
  'admin-swaps': {
    about: 'Review subscriber swap requests and fund the Uniswap pool on Base.',
    steps: ['Check each request\'s quote and wallet balance.', 'Press Approve to run it on-chain, or Reject with a reason.', 'Run your own swaps from the treasury wallet when needed.'],
  },
  'admin-clients': {
    about: 'Every subscriber account: wallet, subscription status, limits and balances.',
    steps: ['Search for a subscriber and open their details.', 'Credit BETH, waive a subscription or adjust limits as needed.'],
  },
  'admin-transactions': {
    about: 'A full history of BETH movements, credit draws and payments across all subscribers.',
    steps: ['Scroll to find a transaction.', 'Open the on-chain link to verify it on the block explorer.'],
  },
  'admin-checks': {
    about: 'All checks issued on the platform and their current status.',
    steps: ['Review issued, claimed and cashed checks.', 'Press Verify to open a check\'s details.'],
  },
  'admin-credit-lines': {
    about: 'Review, approve and manage subscriber credit lines and their interest-only payments.',
    steps: [
      'Open a pending request and review the subscriber and collateral.',
      'Approve with a limit, or decline.',
      'Track usage and payment status. Due payments are collected in BETH automatically, or press Collect due payments now.',
    ],
  },
  'admin-redemptions': {
    about: 'Checks that have been cashed or redeemed, with payout details.',
    steps: ['Review each cashed check and its payout.', 'Use the reference to reconcile with your bank records.'],
  },
  'admin-tax-forms': {
    about: 'Form 8824 records for every customer, ready to review or print.',
    steps: ['Pick a customer and transaction.', 'Open the form to review or print it.'],
  },
  'admin-ledger': {
    about: 'The receivables ledger and valuation policy: monthly interest received and any missed payments.',
    steps: ['Review interest received by month.', 'Follow up on missed payments listed here.'],
  },
  'admin-treasury-check': {
    about: 'Control the BETH USD Treasury Check contract: reserves, minting, collateral, pledges and on-chain activity.',
    steps: [
      'Record reserves before minting. Every BETH must be backed $1 for $1.',
      'Mint, pledge or release as needed, and keep the collateral figures current.',
      'Press Fund pool on the BETH/USDC Uniswap pool card to split treasury USDC between the reserve and the pool.',
    ],
  },
  'admin-eth-sales': {
    about: 'ETH purchases subscribers made through the app for gas and on-chain fees.',
    steps: ['Review each purchase and its delivery status.', 'Press Retry Distribution, or look into any purchase that did not complete.'],
  },
  'admin-gas-funding': {
    about: 'Send ETH to subscriber wallets so they can pay network gas.',
    steps: ['Find the subscriber, enter the ETH amount and press send.', 'Check the transaction link to confirm it arrived.'],
  },
  'admin-contracts': {
    about: 'Smart contract and wallet operations: issuance network, bridging ETH, subscriber gas top-ups and low-balance alerts.',
    steps: ['Confirm the issuance network and contract addresses.', 'Bridge ETH or top up subscriber gas when balances run low.', 'Deploy or verify contracts only when you are upgrading.'],
  },
  'admin-market': {
    about: 'The BETH market on Uniswap: pool price, liquidity and trading activity.',
    steps: ['Check that the pool price stays near $1.00.', 'Review liquidity before approving large swaps.'],
  },
};
